export default class ValidationResult {
    isValid = true
    errorMessage = ""
}